import { useCallback, useState } from 'react'
import KampaniePlacowkiService from '@/services/KampaniePlacowkiService'

export default function usePlacowkaKampanieData(placowkaId) {
	const [data, setData] = useState([])
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(null)
	const [totalCount, setTotalCount] = useState(0)

	const loadData = useCallback(async () => {
		if (!placowkaId) {
			setData([])
			setTotalCount(0)
			setLoading(false)
			return
		}

		setLoading(true)
		setError(null)

		const result = await KampaniePlacowkiService.getByPlacowka(placowkaId, {
			limit: 200,
			sortColumn: '_id',
			sortDirection: 'desc',
		})

		if (result.error) {
			setError(result.error)
			setData([])
			setTotalCount(0)
		} else {
			setData(result.data)
			setTotalCount(result.totalCount)
		}

		setLoading(false)
	}, [placowkaId])

	return {
		data,
		loading,
		error,
		totalCount,
		loadData,
	}
}
